import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { DataFieldService } from '@fi-app/data-field/data-field.service';
import { Transition } from '@uirouter/core';

export const FiBusinessUnitStateResolveBusinessUnitDataFields = [
    FiStateService,
    DataFieldService,
    Transition,
    FiBusinessUnitStateResolveBusinessUnitDataFields_resolveFunc,
];

export function FiBusinessUnitStateResolveBusinessUnitDataFields_resolveFunc(
    fiStateService: FiStateService,
    dataFieldService: DataFieldService,
    tr: Transition,
) {
    return dataFieldService.getUnitFields(fiStateService.getParams(tr).Id);
}
